<mat-form-field class="example-full-width">
  <mat-select [(ngModel)]="ruleId" [disabled]="!editMode">
    @for (rule of rules; track rule) {
      <mat-option [value]="rule.id" (onSelectionChange)="onRuleChange(rule, $event, undefined)">
        {{ rule.name }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>

@if (selected) {
  <app-nested-panel-form-field
    [fields]="fields"
    [canAdd]="false"
    [editMode]="editMode"
    [fieldConfig]="selectedFieldConfig"
    [(formGroup)]="formGroup"
    [(data)]="ruleData"></app-nested-panel-form-field>
}
